































import { Component, Mixins, Prop } from 'vue-property-decorator';
import DateMethods from '@/mixins/DateMethods.vue';

@Component({
    name: 'TicketInternalNote',
})
export default class TicketInternalNote extends Mixins(
    DateMethods,
) {
    @Prop({ default: 'bg-amber-1' }) public bgColor: string;
    @Prop({ default: '' }) public wrapperClass: string;
    @Prop({ default: 'fz-15' }) public headerFontSize: string;
    @Prop({ default: 'fz-16' }) public contentFontSize: string;
    @Prop({ required: true }) public note: any;
}
